// --- HELPER IMPORTS ---
// None - planner.js is now self-contained

export const MASTER_DRILL_DB = [

    // --- 1. Batting Drills ---
    // Category: Technical Foundation
    {
        drill_id: 'batt_tech_01', name: 'The Gate Drill', role_focus: 'Batting', category: 'Technical Foundation',
        setup_instructions: 'Set up two cones as a narrow gate. Drive ball through them.',
        execution_steps: ['Align feet', 'High elbow', 'Drive straight'],
        recommended_volume: '3 Sets / 20 Reps',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Solo', 'Straight Drive', 'Mechanics']
    },
    {
        drill_id: 'batt_tech_02', name: 'Tram Tracks', role_focus: 'Batting', category: 'Technical Foundation',
        setup_instructions: 'Draw two lines. Keep bat swing between them.',
        execution_steps: ['Backlift inside lines', 'Downswing in channel', 'Hold finish'],
        recommended_volume: '3 Sets / 15 Reps',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Solo', 'Alignment', 'LBW']
    },
    {
        drill_id: 'batt_tech_03', name: 'Top Hand Isolation', role_focus: 'Batting', category: 'Technical Foundation',
        setup_instructions: 'Hold bat with top hand only. Partner feeds drop.',
        execution_steps: ['Step forward', 'Drive with control', 'Prevent bottom hand takeover'],
        recommended_volume: '3 Sets / 15 Balls',
        constraints: { min_players: 2, space_req: 'Net' },
        tags: ['Partner', 'Control', 'Edges']
    },
    {
        drill_id: 'batt_tech_04', name: 'Chin on Shoulder Shadow', role_focus: 'Batting', category: 'Technical Foundation',
        setup_instructions: 'Perform drive in mirror. freeze at contact.',
        execution_steps: ['Check chin is on shoulder', 'Head over ball', 'Balance'],
        recommended_volume: '3 Sets / 10 Reps',
        constraints: { min_players: 1, space_req: 'Home' },
        tags: ['Solo', 'Balance', 'Falling Over']
    },
    {
        drill_id: 'batt_tech_05', name: 'Narrow Stance Balance', role_focus: 'Batting', category: 'Technical Foundation',
        setup_instructions: 'Stance with feet 6 inches apart.',
        execution_steps: ['Trigger movement', 'Maintain head stability', 'Play shot'],
        recommended_volume: '3 Sets / 10 Reps',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Solo', 'Balance', 'Head Falling']
    },
    // Category: Against Pace
    {
        drill_id: 'batt_pace_01', name: 'The Two-Ball Drop', role_focus: 'Batting', category: 'Against Pace',
        setup_instructions: 'Hold two balls. Drop both. Hit off-side one.',
        execution_steps: ['Focus on release', 'Decide quickly', 'Execute drive'],
        recommended_volume: '3 Sets / 10 Reps',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Solo', 'Reaction', 'Timing']
    },
    {
        drill_id: 'batt_pace_02', name: 'Off-Stump Guard', role_focus: 'Batting', category: 'Against Pace',
        setup_instructions: 'Take guard on Off-Stump instead of Middle/Leg.',
        execution_steps: ['Leave wide balls', 'Play only at stumps', 'Spatial awareness'],
        recommended_volume: '15 Mins',
        constraints: { min_players: 2, space_req: 'Net' },
        tags: ['Partner', 'Judgment', 'Caught Slip']
    },
    {
        drill_id: 'batt_pace_03', name: 'Colored Ball Feeds', role_focus: 'Batting', category: 'Against Pace',
        setup_instructions: 'Partner throws Red or White ball.',
        execution_steps: ['Drive Red', 'Leave White', 'Quick decision'],
        recommended_volume: '3 Sets / 12 Balls',
        constraints: { min_players: 2, space_req: 'Net' },
        tags: ['Partner', 'Decision Making', 'Chasing Wide']
    },
    {
        drill_id: 'batt_pace_04', name: 'Shadow Out-swinger', role_focus: 'Batting', category: 'Against Pace',
        setup_instructions: 'Visualize ball shaping away.',
        execution_steps: ['Soft hands', 'Play inside line', 'Let ball come to you'],
        recommended_volume: '3 Sets / 10 Reps',
        constraints: { min_players: 1, space_req: 'Home' },
        tags: ['Solo', 'Visualization', 'Edges']
    },
    // Category: Against Bounce
    {
        drill_id: 'batt_bounce_01', name: 'Soft Ball Chest Throws', role_focus: 'Batting', category: 'Against Bounce',
        setup_instructions: 'Partner throws tennis ball at chest height.',
        execution_steps: ['Rock back', 'Roll wrists', 'Pull shot execution'],
        recommended_volume: '3 Sets / 15 Balls',
        constraints: { min_players: 2, space_req: 'Net' },
        tags: ['Partner', 'Confidence', 'Fear of Pace']
    },
    {
        drill_id: 'batt_bounce_02', name: 'High Tee Cuts', role_focus: 'Batting', category: 'Against Bounce',
        setup_instructions: 'Place ball on high tee (waist height).',
        execution_steps: ['Extend arms', 'Slash horizontal bat', 'Control follow through'],
        recommended_volume: '3 Sets / 20 Balls',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Solo', 'Execution', 'Mistiming']
    },
    {
        drill_id: 'batt_bounce_03', name: 'The Cross-Step Shadow', role_focus: 'Batting', category: 'Against Bounce',
        setup_instructions: 'Practice moving back-foot across to off-stump.',
        execution_steps: ['Back and across', 'Balanced base', 'Mime pull shot'],
        recommended_volume: '3 Sets / 10 Reps',
        constraints: { min_players: 1, space_req: 'Home' },
        tags: ['Solo', 'Footwork', 'Top Edges']
    },
    {
        drill_id: 'batt_bounce_04', name: 'Rapid Fire Ducks', role_focus: 'Batting', category: 'Against Bounce',
        setup_instructions: 'Feeder throws rapid bouncers.',
        execution_steps: ['Sway or duck', 'Keep eyes on ball', 'Do not fend'],
        recommended_volume: '3 Sets / 12 Balls',
        constraints: { min_players: 2, space_req: 'Net' },
        tags: ['Partner', 'Evasion', 'Gloving']
    },
    // Category: Against Spin
    {
        drill_id: 'batt_spin_01', name: 'The Charge Drill', role_focus: 'Batting', category: 'Against Spin',
        setup_instructions: 'Start 2 steps down pitch. Partner feeds loop.',
        execution_steps: ['Quick feet', 'Get to pitch', 'Drive'],
        recommended_volume: '3 Sets / 10 Balls',
        constraints: { min_players: 2, space_req: 'Net' },
        tags: ['Partner', 'Footwork', 'Stumped']
    },
    {
        drill_id: 'batt_spin_02', name: 'One-Knee Sweep', role_focus: 'Batting', category: 'Against Spin',
        setup_instructions: 'Start on back knee.',
        execution_steps: ['Sweep ball along ground', 'Roll wrists', 'Head forward'],
        recommended_volume: '3 Sets / 15 Balls',
        constraints: { min_players: 2, space_req: 'Net' },
        tags: ['Partner', 'Execution', 'Top Edge']
    },
    {
        drill_id: 'batt_spin_03', name: 'Crease Depth Drill', role_focus: 'Batting', category: 'Against Spin',
        setup_instructions: 'Mark line deep in crease. Step back to play.',
        execution_steps: ['Use depth', 'Create time', 'Cut or Pull'],
        recommended_volume: '3 Sets / 10 Balls',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Solo', 'Depth', 'Bat-Pad Catch']
    },

    // --- 2. Bowling Drills ---
    // Category: Action & Rhythm
    {
        drill_id: 'bowl_action_01', name: '6-Step Walk Through', role_focus: 'Bowling', category: 'Action & Rhythm',
        setup_instructions: 'Walk through bowling action focusing on arm path.',
        execution_steps: ['Consistent steps', 'High arm', 'Smooth release'],
        recommended_volume: '5 Mins',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Solo', 'Action', 'No Balls']
    },
    {
        drill_id: 'bowl_action_02', name: 'Blindfold Loading', role_focus: 'Bowling', category: 'Action & Rhythm',
        setup_instructions: 'Load up and jump blindfolded.',
        execution_steps: ['Feel body position', 'Stable base', 'Vertical jump'],
        recommended_volume: '3 Sets / 5 Reps',
        constraints: { min_players: 1, space_req: 'Home' },
        tags: ['Solo', 'Proprioception', 'Inconsistency']
    },
    {
        drill_id: 'bowl_action_03', name: 'Wall Wrist Snap', role_focus: 'Bowling', category: 'Action & Rhythm',
        setup_instructions: 'Stand near wall. Snap wrist so seam stays vertical.',
        execution_steps: ['Vertical seam', 'Strong snap', 'Backspin'],
        recommended_volume: '3 Sets / 15 Reps',
        constraints: { min_players: 1, space_req: 'Home' },
        tags: ['Solo', 'Seam', 'Flat Seam']
    },
    // Category: Accuracy
    {
        drill_id: 'bowl_acc_01', name: 'Target: Good Length', role_focus: 'Bowling', category: 'Accuracy',
        setup_instructions: 'Place mat/cones at good length.',
        execution_steps: ['Hit target 4/6 times', 'Repeat action', 'Focus on spot'],
        recommended_volume: '4 Overs',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Net', 'Control', 'High Economy']
    },
    {
        drill_id: 'bowl_acc_02', name: 'The "Channel" Drill', role_focus: 'Bowling', category: 'Accuracy',
        setup_instructions: 'Two lines 6 inches outside off-stump.',
        execution_steps: ['Land between lines', 'Consistent line', 'Force play'],
        recommended_volume: '4 Overs',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Net', 'Line', 'Bowling Wide']
    },
    // Category: Variations
    {
        drill_id: 'bowl_var_01', name: 'Target: The Shoe (Yorker)', role_focus: 'Bowling', category: 'Variations',
        setup_instructions: 'Place old shoe on crease.',
        execution_steps: ['Hit shoe on full', 'Late dip', 'Attack stumps'],
        recommended_volume: '2 Overs',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Net', 'Death Bowling', 'Full Tosses']
    },
    {
        drill_id: 'bowl_var_02', name: 'String Line Bouncers', role_focus: 'Bowling', category: 'Variations',
        setup_instructions: 'String at shoulder height.',
        execution_steps: ['Ball pass over string', 'Dip sharply', 'Aggressive length'],
        recommended_volume: '2 Overs',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Net', 'Aggression', 'Short Bowling']
    },
    {
        drill_id: 'bowl_var_03', name: 'Spin Rev Count', role_focus: 'Bowling', category: 'Variations',
        setup_instructions: 'Use half-painted ball. Film release.',
        execution_steps: ['Max rotation', 'Drift', 'Drop'],
        recommended_volume: '20 Balls',
        constraints: { min_players: 1, space_req: 'Net' },
        tags: ['Solo', 'Spin', 'Not Turning']
    },

    // --- 3. Fielding Drills ---
    {
        drill_id: 'field_catch_01', name: 'Wall Rebound Catches', role_focus: 'Fielding', category: 'Catching',
        setup_instructions: 'Throw ball against uneven wall.',
        execution_steps: ['React to bounce', 'Soft hands', 'Watch ball into hands'],
        recommended_volume: '5 Mins',
        constraints: { min_players: 1, space_req: 'Wall' },
        tags: ['Solo', 'Reflexes', 'Dropped Catches']
    },
    {
        drill_id: 'field_catch_02', name: 'High Catch Spirals', role_focus: 'Fielding', category: 'Catching',
        setup_instructions: 'Partner hits ball high.',
        execution_steps: ['Run to ball', 'Steady head', 'Reverse cup'],
        recommended_volume: '10 Catches',
        constraints: { min_players: 2, space_req: 'Outfield' },
        tags: ['Partner', 'Outfield', 'Boundary Errors']
    },
    {
        drill_id: 'field_ground_01', name: 'Attack & Throw', role_focus: 'Fielding', category: 'Ground Fielding',
        setup_instructions: 'Sprint to ball, pick up one handed.',
        execution_steps: ['Attack ball', 'Clean pick up', 'Throw at stump'],
        recommended_volume: '10 Reps',
        constraints: { min_players: 1, space_req: 'Outfield' },
        tags: ['Open Space', 'Agility', 'Misfields']
    },
    {
        drill_id: 'field_ground_02', name: 'The Long Barrier', role_focus: 'Fielding', category: 'Ground Fielding',
        setup_instructions: 'Practice kneeling barrier technique.',
        execution_steps: ['Knee down', 'Body behind ball', 'Secure gather'],
        recommended_volume: '15 Reps',
        constraints: { min_players: 1, space_req: 'Home' },
        tags: ['Solo', 'Safety', 'Letting Ball Through']
    },

    // --- 4. Fitness Drills ---
    {
        drill_id: 'fit_speed_01', name: '22-Yard Shuttles', role_focus: 'Fitness', category: 'Speed & Stamina',
        setup_instructions: 'Sprint pitch length. Turn. Repeat.',
        execution_steps: ['Max effort sprint', 'Quick turn', 'Simulate runs'],
        recommended_volume: '3 Sets / 6 Reps',
        constraints: { min_players: 1, space_req: 'Pitch' },
        tags: ['Open Space', 'Cardio', 'Fatigue']
    },
    {
        drill_id: 'fit_speed_02', name: 'Reaction Sprints', role_focus: 'Fitness', category: 'Speed & Stamina',
        setup_instructions: 'Lie on stomach. Clap. Get up and sprint.',
        execution_steps: ['Fast up', 'Drive off ground', 'Sprint 10m'],
        recommended_volume: '10 Reps',
        constraints: { min_players: 1, space_req: 'Open Space' },
        tags: ['Open Space', 'Explosiveness', 'Slow Starts']
    },
    {
        drill_id: 'fit_str_01', name: 'Bodyweight Circuit', role_focus: 'Fitness', category: 'Strength & Power',
        setup_instructions: 'Squats, Lunges, Pushups, Burpees.',
        execution_steps: ['30s work', '10s rest', 'Maintain form'],
        recommended_volume: '3 Rounds',
        constraints: { min_players: 1, space_req: 'Home' },
        tags: ['Solo', 'Strength', 'Weak Throwing']
    },
    {
        drill_id: 'fit_str_02', name: 'Medicine Ball Slams', role_focus: 'Fitness', category: 'Strength & Power',
        setup_instructions: 'Slam ball into ground.',
        execution_steps: ['Full extension', 'Explosive slam', 'Engage core'],
        recommended_volume: '3 Sets / 10 Reps',
        constraints: { min_players: 1, space_req: 'Gym' },
        tags: ['Gym', 'Power', 'Bat Speed']
    },
    {
        drill_id: 'fit_rec_01', name: 'Yoga for Cricketers', role_focus: 'Fitness', category: 'Recovery',
        setup_instructions: 'Focus on hamstrings, hips, and lower back.',
        execution_steps: ['Hold poses', 'Deep breathing', 'Release tension'],
        recommended_volume: '20 Mins',
        constraints: { min_players: 1, space_req: 'Home' },
        tags: ['Solo', 'Flexibility', 'Stiffness']
    },

    // --- 5. Mental Drills ---
    {
        drill_id: 'ment_vis_01', name: 'Audio: Facing 145kph', role_focus: 'Mental', category: 'Visualization',
        setup_instructions: 'Guided audio track visualizing high pace.',
        execution_steps: ['Close eyes', 'See the ball', 'Feel the timing'],
        recommended_volume: '10 Mins',
        constraints: { min_players: 1, space_req: 'Quiet' },
        tags: ['Audio', 'Mental', 'Anxiety']
    },
    {
        drill_id: 'ment_vis_02', name: 'Audio: The Chase', role_focus: 'Mental', category: 'Visualization',
        setup_instructions: 'Visualize scoring 10 runs in the last over.',
        execution_steps: ['Feel pressure', 'Stay calm', 'Execute plan'],
        recommended_volume: '10 Mins',
        constraints: { min_players: 1, space_req: 'Quiet' },
        tags: ['Audio', 'Pressure', 'Choking']
    },
    {
        drill_id: 'ment_vr_01', name: 'VR: Survival Mode', role_focus: 'Mental', category: 'VR Training',
        setup_instructions: 'Survive 5 overs of Test match bowling.',
        execution_steps: ['Use headset', 'Focus on defence', 'Protect wicket'],
        recommended_volume: '5 Overs',
        constraints: { min_players: 1, space_req: 'VR Headset' },
        tags: ['VR', 'Patience', '']
    },
    {
        drill_id: 'ment_vr_02', name: 'VR: Spin Merlins', role_focus: 'Mental', category: 'VR Training',
        setup_instructions: 'Read the googly vs leg spin.',
        execution_steps: ['Watch hand', 'Pick length', 'React'],
        recommended_volume: '30 Balls',
        constraints: { min_players: 1, space_req: 'VR Headset' },
        tags: ['VR', 'Reading Spin', '']
    },
];

// --- LOGIC FUNCTIONS (Restored) ---

export const resolveDailyDrills = (dayPlan, userProfile, customDrills = []) => {
    let drills = [];
    const mergedDB = [...MASTER_DRILL_DB, ...customDrills];

    // 1. Resolve Base Plan (Injected or Default)
    if (dayPlan.drill_id) {
        const drill = mergedDB.find(d => d.drill_id === dayPlan.drill_id);
        if (drill) drills.push(drill);
    } else if (dayPlan.type === 'Technical') {
        const role = userProfile.role || 'Batter';
        if (role.includes('Batter')) {
            drills = MASTER_DRILL_DB.filter(d => d.role_focus === 'Batting' && d.category === 'Technical Foundation').slice(0, 2);
        } else if (role.includes('Bowler')) {
            drills = MASTER_DRILL_DB.filter(d => d.role_focus === 'Bowling' && d.category === 'Accuracy').slice(0, 2);
        }
    }

    // 2. Merge Custom Additions (Persisted)
    if (dayPlan.custom_drills && Array.isArray(dayPlan.custom_drills)) {
        const customs = dayPlan.custom_drills
            .map(id => mergedDB.find(d => d.drill_id === id))
            .filter(Boolean)
            .map(d => ({ ...d, isCustom: true }));

        drills = [...drills, ...customs];
    }

    return drills;
};

export const calculateSessionDuration = (drills, isTimeCrunched = false) => {
    // Mock Base Duration: 15 mins per drill + 10 warm/cool
    if (isTimeCrunched) {
        return 20; // Hard cap
    }
    return (drills.length * 15) + 15;
};

export const adjustDrillIntensity = (volumeString, intensityLevel) => {
    if (!volumeString) return volumeString;

    // Simple regex to find numbers
    return volumeString.replace(/(\d+)/g, (match) => {
        const val = parseInt(match);
        if (intensityLevel === 'low') return Math.floor(val * 0.7);
        if (intensityLevel === 'high') return Math.floor(val * 1.3);
        return val;
    });
};

export const getAlternativeDrill = (originalDrill, constraintType) => {
    // 1. Identification
    const role = originalDrill.role_focus;
    const category = originalDrill.category;

    // 2. Filtering for Alternatives
    const candidates = MASTER_DRILL_DB.filter(d =>
        d.drill_id !== originalDrill.drill_id && // Not the same drill
        d.role_focus === role &&
        d.category === category
    );

    // 3. Apply specific constraint logic
    if (constraintType === 'No Partner') {
        return candidates.find(d => d.constraints.min_players === 1) || null;
    }

    if (constraintType === 'No Equipment') {
        return candidates.find(d => d.name.includes('Shadow') || d.execution_steps.some(s => s.includes('Shadow'))) || null;
    }

    return candidates[0] || null;
};

export const generateWeeklyPlan = (phase = 'In-Season') => {
    // Generate dates for current week (Mon-Sun)
    const today = new Date();
    const currentDay = today.getDay(); // 0 is Sunday
    const distanceToMon = currentDay === 0 ? -6 : 1 - currentDay;

    // Core structure
    const structure = [
        { day: 'Monday', type: 'Technical' },
        { day: 'Tuesday', type: 'Fitness' },
        { day: 'Wednesday', type: 'Volume' },
        { day: 'Thursday', type: 'Rest' },
        { day: 'Friday', type: 'Match Day' },
        { day: 'Saturday', type: 'Technical' },
        { day: 'Sunday', type: 'Mental' }
    ];

    return structure.map((s, i) => {
        const d = new Date(today);
        d.setDate(today.getDate() + distanceToMon + i);
        return {
            ...s,
            date: d.toISOString().split('T')[0],
            focus: s.type === 'Rest' ? 'Recovery' : 'General Skill',
            isLocked: false,
            isCompleted: false,
            drill_id: null
        };
    });
};

export const getCorrectiveDrill = (dismissal, shotType, role) => {
    // Filter logic based on triggers in MASTER_DRILL_DB
    const corrections = MASTER_DRILL_DB.filter(drill => {
        // 1. Must match role
        // if (drill.role_focus !== role) return false; (Relaxed for now as role strings might vary)

        // 2. Check Logic Triggers
        const triggers = drill.logic_triggers || {};

        // Match Dismissal?
        const dismissalMatch = triggers.dismissal?.some(d => dismissal?.includes(d));
        // Match Shot? (Indirectly checks error tags or target skills, can be expanded)
        // For simple MVP we focus on dismissal

        return dismissalMatch;
    });

    return corrections.length > 0 ? corrections[0] : null;
};

export const injectDrillIntoPlan = (currentPlan, drill) => {
    if (!drill) return currentPlan;

    // Clone plan
    const newPlan = [...currentPlan];

    // Find first available training day (Not Rest, Not Match Day)
    // Starting from tomorrow (mock logic, in real app find next suitable session)
    const targetIndex = newPlan.findIndex(d =>
        d.type !== 'Rest' &&
        d.type !== 'Match Day' &&
        !d.isCompleted
    );

    if (targetIndex !== -1) {
        newPlan[targetIndex] = {
            ...newPlan[targetIndex],
            isInjected: true,
            focus: `Corrective: ${drill.name}`,
            drill_id: drill.drill_id
        };
    }

    return newPlan;
};
